<template>
    <!-- 顶部 返回按钮 和 面包屑 展示所处层级结构 -->
    <div >
      <div class="content-container">
        <ContactList :clientId="clientId" :clientName="clientName" @returnDetail="$emit('returnDetail')" @returnClientList="$emit('returnClientList')" @refresh='refresh' :refreshId="refreshId" />
      </div>
    </div>
</template>

<script>
import ContactList from "@/component/Client/Contact/ContactList"
export default {
    name: "Contact",
    components: {
        ContactList,
    },
    props: {
        clientId: {
            required: true
        },
        clientName: {
            required: true
        },
        refreshId: {
          required: true
        }
    },
    methods: {
      refresh() {
        this.$emit('refresh')
      }
    }
}
</script>

<style scoped>
  .content-container{
    /* padding: 0px; */
    width: 100%;
  }

</style>
